module.exports = __webpack_public_path__ + "img/icon-sadadream.8bf1a3bb.svg";